/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Refund_BtnInputs */

const en_delivery_refund_btn = /** @type {(inputs: Delivery_Refund_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refund Order`)
};

const es_delivery_refund_btn = /** @type {(inputs: Delivery_Refund_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reembolsar Pedido`)
};

const fr_delivery_refund_btn = /** @type {(inputs: Delivery_Refund_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rembourser la commande`)
};

const de_delivery_refund_btn = /** @type {(inputs: Delivery_Refund_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestellung erstatten`)
};

const id_delivery_refund_btn = /** @type {(inputs: Delivery_Refund_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kembalikan Dana Pesanan`)
};

/** @type {(inputs: Delivery_Refund_BtnInputs) => LocalizedString} */
const ja_delivery_refund_btn = en_delivery_refund_btn;

/** @type {(inputs: Delivery_Refund_BtnInputs) => LocalizedString} */
const zh_delivery_refund_btn = en_delivery_refund_btn;

/** @type {(inputs: Delivery_Refund_BtnInputs) => LocalizedString} */
const ar_delivery_refund_btn = en_delivery_refund_btn;

/** @type {(inputs: Delivery_Refund_BtnInputs) => LocalizedString} */
const it_delivery_refund_btn = en_delivery_refund_btn;

/** @type {(inputs: Delivery_Refund_BtnInputs) => LocalizedString} */
const ru_delivery_refund_btn = en_delivery_refund_btn;

/** @type {(inputs: Delivery_Refund_BtnInputs) => LocalizedString} */
const pt_delivery_refund_btn = en_delivery_refund_btn;

/** @type {(inputs: Delivery_Refund_BtnInputs) => LocalizedString} */
const ko_delivery_refund_btn = en_delivery_refund_btn;

/**
* | output |
* | --- |
* | "Refund Order" |
*
* @param {Delivery_Refund_BtnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_refund_btn = /** @type {((inputs?: Delivery_Refund_BtnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Refund_BtnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_refund_btn(inputs)
	if (locale === "es") return es_delivery_refund_btn(inputs)
	if (locale === "fr") return fr_delivery_refund_btn(inputs)
	if (locale === "de") return de_delivery_refund_btn(inputs)
	if (locale === "ja") return ja_delivery_refund_btn(inputs)
	if (locale === "zh") return zh_delivery_refund_btn(inputs)
	if (locale === "ar") return ar_delivery_refund_btn(inputs)
	if (locale === "id") return id_delivery_refund_btn(inputs)
	if (locale === "it") return it_delivery_refund_btn(inputs)
	if (locale === "ru") return ru_delivery_refund_btn(inputs)
	if (locale === "pt") return pt_delivery_refund_btn(inputs)
	return ko_delivery_refund_btn(inputs)
});